export default __webpack_public_path__ + "static/media/assets-ads.1e9d3319.jpg";